import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'dqsDate',
})
export class DqsDatePipe implements PipeTransform {
  transform(value: string, time = false, onlyTime = false): string {
    if (!value) {
      return;
    }

    let format = 'MM/dd/yyyy';

    if (time) {
      format = onlyTime ? 'HH:mm' : `${format} HH:mm`;
    }

    return formatDate(value, format, 'en-US');
  }
}
